import { useState, useEffect } from "react";
import axiosInstance from "../axiosConfig";
import { handleError } from "../services/handleError";
import { showToast } from "./Toast";

const diasSemana = [
    "Domingo",
    "Segunda-feira",
    "Terça-feira",
    "Quarta-feira",
    "Quinta-feira",
    "Sexta-feira",
    "Sábado",
];

const HorarioFuncionamento = () => {
    const [horarios, setHorarios] = useState(
        diasSemana.map(() => [{ abertura: "", fechamento: "" }])
    );
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        buscarHorarioFuncionamento();
    }, []);

    const buscarHorarioFuncionamento = () => {
        setLoading(true);
        axiosInstance.get("Configs/HorarioFuncionamento")
            .then((response) => {
                const horariosRecebidos = diasSemana.map((_, index) => {
                    const horariosDoDia = response.data
                        .filter((h) => h.diaSemana === index)
                        .map((h) => ({
                            abertura: h.horarioAbertura.substring(0, 5),
                            fechamento: h.horarioFechamento.substring(0, 5)
                        }));

                    return horariosDoDia.length > 0 ? horariosDoDia : [{ abertura: "", fechamento: "" }];
                });

                setHorarios(horariosRecebidos);
            })
            .catch((error) => handleError(error, "Erro ao buscar horários."))
            .finally(() => setLoading(false));
    };

    const adicionarHorario = (indiceDia) => {
        setHorarios((prev) => {
            const novosHorarios = [...prev];
            novosHorarios[indiceDia].push({ abertura: "", fechamento: "" });
            return novosHorarios;
        });
    };

    const removerHorario = (indiceDia, indiceHorario) => {
        setHorarios((prev) => {
            const novosHorarios = [...prev];
            novosHorarios[indiceDia].splice(indiceHorario, 1);
            return novosHorarios;
        });
    };

    const atualizarHorario = (indiceDia, indiceHorario, campo, valor) => {
        setHorarios((prev) => {
            const novosHorarios = [...prev];
            novosHorarios[indiceDia][indiceHorario][campo] = valor;
            return novosHorarios;
        });
    };

    const salvarHorarios = () => {
        setLoading(true);

        const formatarParaTimeSpan = (hora) => {
            return hora ? `${hora}:00` : null;
        };

        const horariosFormatados = [];
        let erroValidacao = false;
        let mensagensErro = [];

        horarios.forEach((horarioDia, indiceDia) => {
            const horariosOrdenados = [...horarioDia].sort((a, b) => a.abertura.localeCompare(b.abertura));

            for (let i = 0; i < horariosOrdenados.length; i++) {
                const h = horariosOrdenados[i];

                if (!h.abertura || !h.fechamento) continue;

                if (h.abertura >= h.fechamento) {
                    mensagensErro.push(`Erro: No dia ${diasSemana[indiceDia]}, o horário de abertura deve ser menor que o de fechamento.`);
                    erroValidacao = true;
                }

                if (i > 0) {
                    const hAnterior = horariosOrdenados[i - 1];
                    if (h.abertura < hAnterior.fechamento) {
                        mensagensErro.push(`Erro: No dia ${diasSemana[indiceDia]}, os horários não podem se sobrepor.`);
                        erroValidacao = true;
                    }
                }

                horariosFormatados.push({
                    diaSemana: indiceDia,
                    horarioAbertura: formatarParaTimeSpan(h.abertura),
                    horarioFechamento: formatarParaTimeSpan(h.fechamento),
                });
            }
        });

        if (erroValidacao) {
            handleError(mensagensErro.join("\n"));
            setLoading(false);
            return;
        }

        axiosInstance
            .post("/Configs/HorarioFuncionamento", horariosFormatados)
            .catch((error) => handleError(error, "Erro ao salvar horários."))
            .finally(() => {setLoading(false); showToast("Sucesso!", "success", 3000, "Horários atualizados com sucesso")});
    };

    return (
        <div className="rounded-lg w-full max-h-[80vh] flex flex-col">
            {loading ? (
                <p className="text-gray-500 flex-grow flex items-center justify-center">Carregando...</p>
            ) : (
                <>
                    {/* Conteúdo com scroll interno */}
                    <div className="flex-1 space-y-6 pr-2">
                        {diasSemana.map((dia, indiceDia) => {
                            const horariosDia = horarios[indiceDia];

                            return (
                                <div key={indiceDia} className="border-b pb-4">
                                    <h3 className="text-gray-700 font-medium mb-3">{dia}</h3>

                                    {horariosDia.map((horario, indiceHorario) => (
                                        <div key={indiceHorario} className="flex items-center gap-2 mb-2">
                                            <input
                                                type="time"
                                                value={horario.abertura}
                                                onChange={(e) =>
                                                    atualizarHorario(indiceDia, indiceHorario, "abertura", e.target.value)
                                                }
                                                className="border rounded-lg px-3 py-2 w-1/2 text-gray-700 focus:ring-2 focus:ring-blue-500"
                                            />
                                            <span className="text-gray-500">às</span>
                                            <input
                                                type="time"
                                                value={horario.fechamento}
                                                onChange={(e) =>
                                                    atualizarHorario(indiceDia, indiceHorario, "fechamento", e.target.value)
                                                }
                                                className="border rounded-lg px-3 py-2 w-1/2 text-gray-700 focus:ring-2 focus:ring-blue-500"
                                            />
                                            {horariosDia.length > 1 && (
                                                <button
                                                    onClick={() => removerHorario(indiceDia, indiceHorario)}
                                                    className="text-red-500 hover:text-red-700 text-lg"
                                                    aria-label={`Remover horário ${horario.abertura} - ${horario.fechamento}`}
                                                >
                                                    &times;
                                                </button>
                                            )}
                                        </div>
                                    ))}

                                    <button
                                        onClick={() => adicionarHorario(indiceDia)}
                                        className="mt-2 text-sm text-blue-500 hover:underline"
                                    >
                                        + Adicionar horário
                                    </button>
                                </div>
                            );
                        })}
                    </div>

                    {/* Botão fixo na parte inferior do modal */}
                    <div className="sticky bottom-0 bg-white py-4 flex justify-end">
                        <button
                            onClick={salvarHorarios}
                            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50"
                            disabled={loading}
                        >
                            {loading ? "Salvando..." : "Salvar"}
                        </button>
                    </div>
                </>
            )}
        </div>
    );
};

export default HorarioFuncionamento;
